// Used in login-routing.module.ts

// Angular
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

// Services/Types/Helpers
// RXJS/Store
import { OAuth } from "@carnegie-learning/data-access-angular-passport";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "oauth-authorize",
    templateUrl: "./oauth-authorize.component.html",
    styleUrls: ["./oauth-authorize.component.scss"],
    standalone: false
})
export class OauthAuthorizeComponent implements OnInit, OnDestroy {
    API_ROOT = (<any>window).apiHost;

    private ngUnsubscribe = new Subject();

    private authorizeParams: any;

    client: any;

    clientError = false;

    redirectUri = "";

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private oAuthService: OAuth
    ) {}

    ngOnInit() {
        this.activatedRoute.queryParams
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((params) => {
                this.authorizeParams = params;

                this.authorizeParams = {
                    ...this.authorizeParams,
                    api_uri: this.API_ROOT,
                };

                this.oAuthService
                    .checkAuth(this.authorizeParams)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(
                        (response) => {
                            this.redirectUri = response.redirect_uri;
                            if (response.prevAuth) {
                                // user was previously authorized, redirect NOW!
                                window.location.replace(this.redirectUri);
                            } else {
                                this.client = response.client;
                            }
                        },
                        (error) => {
                            this.clientError = true;
                        }
                    );
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    deny() {
        window.location.replace(this.client.redirectUri);
    }

    authorize() {
        this.oAuthService
            .authorize(this.authorizeParams)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (response) => {
                    this.redirectUri = response.redirect_uri;
                    window.location.replace(this.redirectUri);
                },
                (error) => {
                    this.clientError = true;
                }
            );
    }
}
